import { ApiResponseType } from './api';
import { axiosInstance } from './index';


export const organizationService = {
   
   
    async registration( data: any) {
        const { data: responseData } = await axiosInstance.post(`org/registration`,data);
        return responseData as ApiResponseType;
    },

    async editOrganization( data: any) {
        const { data: responseData } = await axiosInstance.post(`org/editOrganization`,data);
        return responseData as ApiResponseType;
    },

    async createOrganization( data: any) {
        const { data: responseData } = await axiosInstance.post(`org/createOrganization`,data);
        return responseData as ApiResponseType;
    },

    async eventregistration( data: any) {
        const { data: responseData } = await axiosInstance.post(`event/registration`,data);
        return responseData as ApiResponseType;
    },
    async getOrganizationFeeDetails(orgId: any) {
        const { data: responseData } = await axiosInstance.get(`org/getOrganizationFeeDetails/${orgId}`);
        return responseData;
    },

    async updateOrganizationPaymentDetails(data: any) {
        const { data: responseData } = await axiosInstance.post(`org/updateOrganizationPayment`, data);
        return responseData;
    },

     async getOrganizationDetailsforVerification(status:any) {
        const { data: responseData } = await axiosInstance.get(`org/getOrganizationDetailsforVerification/${status}`);
        return responseData;
    },

    async checkEmailUnique(email : string){
         const { data: responseData } = await axiosInstance.get(`org/checkEmailUnique/${email}`);
        return responseData;

    },
    async checkMobileUnique(mobileNo:string){
         const { data: responseData } = await axiosInstance.get(`org/checkMobileUnique/${mobileNo}`);
        return responseData;

    },

    async findOrganizationById(orgId:any){
         const { data: responseData } = await axiosInstance.get(`org/findOrgbyId/${orgId}`);
        return responseData;

    },

 async updateOrgApprovals(id:number,data: any) {
        const { data: responseData } = await axiosInstance.put(`org/updateOrganizationApproval/${id}`,data);
        return responseData;
    },

 async getOrgDetailsforPayment(){
    const { data: responseData } = await axiosInstance.get(`org/getOrgDetailsforPayment`);
        return responseData;
 }
    
};